import React from 'react';

import Page from '../WithHeader';
import MobileHeader from '../../../views/PublicRoutes/Dashboard/MobileHeader';

const PublicPage = ({
  hidePublicHeader,
  headerAdditionalContent,
  ...props
}) => (
  <Page
    upperHeader={
      !hidePublicHeader && (
        <MobileHeader headerAdditionalContent={headerAdditionalContent} />
      )
    }
    {...props}
  />
);

export default PublicPage;
